import { useContext } from 'react';
import { IntlContext } from 'react-intl';

// The shared ui/ primitives render inside the app's IntlProvider at runtime,
// but the platform test-suite mounts them bare. Reading the context directly
// lets a missing provider degrade to English instead of throwing the way
// useIntl() does.
export default function useOptionalIntl() {
    return useContext(IntlContext) ?? null;
}
